export default {
    languages: ['en', 'ja'],
    defaultLocale: 'ja',
    fallbackLocale: 'en',
}
